// import { Component, OnInit } from "@angular/core";

// @Component({
//   selector: "app-trip-analytics",
//   templateUrl: "./trip-analytics.component.html",
// })
// export class TripAnalyticsComponent implements OnInit {
//   frequency: number = 7;

//   chartType: string = "bar";
//   chartLabels: string[] = [];
//   chartData: any[] = [];
//   chartOptions: any;

//   // API response format: { date: 'yyyy-mm-dd', tripsCount: number }
//   trips: { date: string; tripsCount: number }[] = [];

//   ngOnInit(): void {
//     this.chartOptions = {
//       responsive: true,
//       scales: {
//         xAxes: [
//           {
//             gridLines: { display: false },
//           },
//         ],
//         yAxes: [
//           {
//             ticks: {
//               beginAtZero: true,
//               precision: 0,
//             },
//           },
//         ],
//       },
//       legend: {
//         display: true,
//       },
//     };

//     // Example call after API
//     this.loadTrips();
//   }

//   loadTrips() {
//     // 🔁 Replace this with actual API response
//     this.trips = [
//       { date: "2026-01-29", tripsCount: 2 },
//       { date: "2026-01-31", tripsCount: 7 },
//       { date: "2026-02-01", tripsCount: 3 },
//     ];

//     this.updateChart();
//   }

//   updateChart() {
//     const result = this.prepareDailyTripCounts(this.trips, this.frequency);

//     this.chartLabels = result.labels;
//     this.chartData = [
//       {
//         data: result.data,
//         label: "Trips",
//         backgroundColor: "#4e73df",
//          hoverBackgroundColor: "#a2ec97",
//       },
//     ];
//   }

//   prepareDailyTripCounts(trips: { date: string; tripsCount: number }[], days: number) {
//     const map = new Map<string, number>();
//     trips.forEach((trip) => {
//       map.set(trip.date, trip.tripsCount);
//     });

//     const labels: string[] = [];
//     const data: number[] = [];

//     for (let i = days - 1; i >= 0; i--) {
//       const d = new Date();
//       d.setDate(d.getDate() - i);
//       const key = d.toISOString().split("T")[0]; // yyyy-mm-dd

//       labels.push(this.formatDate(d));
//       data.push(map.get(key) || 0); // Zero if no trips for that day
//     }

//     return { labels, data };
//   }

//   formatDate(date: Date): string {
//     return date.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//     });
//   }

//   changeFrequency(days: number) {
//     this.frequency = days;
//     this.updateChart();
//   }
// }

import { Component, OnInit } from "@angular/core";
import { EnterpriseService } from "../enterprise.service";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-trip-analytics",
  templateUrl: "./trip-analytics.component.html",
})
export class TripAnalyticsComponent implements OnInit {
  frequency: number = 7;
  chartType: string = "bar";
  chartLabels: string[] = [];
  chartData: any[] = [];
  chartOptions: any;

  enterpriseId: string = "";

  constructor(
    private enterpriseService: EnterpriseService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
  ) {}

  ngOnInit(): void {
    // Get enterpriseId from query params
    this.activatedRoute.queryParams.subscribe((params) => {
      this.enterpriseId = params["id"];
      console.log("Enterprise ID from URL:", this.enterpriseId);
      if (this.enterpriseId) {
        this.loadTrips();
      }
    });

    this.chartOptions = {
      responsive: true,
      scales: {
        xAxes: [
          {
            gridLines: { display: false },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        ],
      },
      legend: {
        display: true,
      },
    };

    this.loadTrips();
  }

  loadTrips() {
    this.spinner.show();
    const body = {
      enterpriseId: this.enterpriseId,
      lastDays: this.frequency,
    };

    this.enterpriseService.getLastTripsCount(body).subscribe((res: any) => {
      this.spinner.hide()
      if (res.statusCode === 200) {
        console.log("res", res);
        this.updateChart(res.data);
      }else{
        this.toast.error(res.message || "something went wrong")
      }
    });
  }

  updateChart(apiData: { date: string; tripsCount: number }[]) {
    const result = this.prepareDailyTripCounts(apiData, this.frequency);

    this.chartLabels = result.labels;
    this.chartData = [
      {
        data: result.data,
        label: "Trips per Day",
        backgroundColor: "#4e73df",
        hoverBackgroundColor: "#6dde76",
      },
    ];
  }

  prepareDailyTripCounts(
    apiData: { date: string; tripsCount: number }[],
    days: number,
  ) {
    const map = new Map<string, number>();
    apiData.forEach((item) => map.set(item.date, item.tripsCount));

    const labels: string[] = [];
    const data: number[] = [];

    for (let i = days - 1; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      const key = d.toISOString().split("T")[0];

      labels.push(this.formatDate(d));
      data.push(map.get(key) || 0);
    }

    return { labels, data };
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  }

  changeFrequency(days: number) {
    this.frequency = days;
    this.loadTrips();
  }
}
